import { metricKeys } from '@pulse/metrics';
import { getDistributionMetrics } from '@src/components/metrics-panel-hz/utils/metricsMapping';

export function expandPercentileMetrics(metricsMap: Record<string, any>) {
  const distributionMap = getDistributionMetrics();
  const avgRequestDuration = metricsMap[metricKeys.AverageRequestDuration];
  if (avgRequestDuration) {
    const distribution = distributionMap[metricKeys.AverageRequestDuration];
    const { percentileMetrics, ...restProps } = avgRequestDuration;
    if (Array.isArray(percentileMetrics)) {
      for (const metric of percentileMetrics) {
        const { name } = metric;
        if (name) {
          metricsMap[name] = {
            ...restProps,
            ...metric,
            active: true,
            relatedAvgMetric: metricKeys.AverageRequestDuration,
            distribution,
          };
        }
      }
    }
  }
}

export function isPercentileMetric(metricInfo) {
  return metricInfo && metricInfo.relatedAvgMetric !== undefined;
}
